import WorthyApi from 'lib/api/worthyApi';
import _ from 'underscore'

export const SET_EXPERIMENTS = Symbol('SET_EXPERIMENTS');
export const SET_CUSTOM_EXPERIMENTS = Symbol('SET_CUSTOM_EXPERIMENTS');
export const UPDATE_CUSTOM_EXPERIMENTS = Symbol('UPDATE_CUSTOM_EXPERIMENTS');

export function setExperiments(userId) {
    let request =
        WorthyApi.setExperiments(userId)
            .then((res)=>{
                return res;
            })
            .catch((error)=>{
                throw error;
            });

    return {
        type:       SET_EXPERIMENTS,
        payload:    request
    }
}

export function setCustomExperiments(experiments) {
    return {
        type:       SET_CUSTOM_EXPERIMENTS,
        payload:    _.mapObject(experiments, function(value){ return {status: true, variant: value.toString()}; })
    }
}

export function updateCustomExperiments(userId, experiments) {
    let request = WorthyApi.updateExperiments(userId, experiments).then((res) => {
        return res;
    }).catch((error) => {
        throw error;
    });

    return {
        type: UPDATE_CUSTOM_EXPERIMENTS,
        payload: request
    }
}
